(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gush-featured-blog"] && !Shopify.designMode) return;
  try {
    
// const swiperEle = document.querySelectorAll(".featured_swiper_gush")
// 	var swiper = new Swiper(`.`, {
// 		slidesPerView: 2,
// 		spaceBetween: 15,
// 		centeredSlide:true,
// 		loop: true,
// 		navigation: {
//           nextEl: ".featured-blog-next",
//           prevEl: ".featured-blog-prev",
//         },
//     // Responsive breakpoints
//     breakpoints: {
//     750: {
//       slidesPerView: 2,
//       spaceBetween: 20,
//     },
// 		990: {
//       slidesPerView: 3,
//       spaceBetween: 20,
//     }
//    }
// });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gush-related-blogs"] && !Shopify.designMode) return;
  try {
    
	var swiper = new Swiper(".gush_related_blog", {
		slidesPerView: 2,
		spaceBetween: 15,
		centeredSlide:true,
		loop: true,
		navigation: {
          nextEl: ".related-blog-next",
          prevEl: ".related-blog-prev",
        },
    // Responsive breakpoints
    breakpoints: {
    750: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
		990: {
      slidesPerView: 3,
      spaceBetween: 20,
    }
   }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lets-care"] && !Shopify.designMode) return;
  try {
    
const tabs = document.querySelectorAll('.lets-care .tab')
const tabContents = document.querySelectorAll('.lets-care .tab-content')

tabs.forEach(tab => {
  tab.addEventListener('click', () => {
	console.log(tab.dataset.tabTarget)
    const target = document.querySelector(tab.dataset.tabTarget)
    tabContents.forEach(tabContent => {
      tabContent.classList.remove('active')
    })
    tabs.forEach(tab => {
      tab.classList.remove('active')
    })
    tab.classList.add('active')
    target.classList.add('active')
  })
})

var swiper = new Swiper(".lets_care-swiper", {
		slidesPerView: "auto",
		centeredSlide:true,
        spaceBetween: 25,
});
	

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-gush-carecleancare"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-gush-copy"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-gush-exterior"]) return;
  try {
    
const options = document.querySelectorAll('.product_variant_selection_container div')
const quantity_box = document.querySelectorAll('.quantity_selection_box div')
const details = document.querySelector('.product_variant_details')
const product_variant = document.querySelector('.current_selected_product_variant')
const product_size = document.querySelector('.current_selected_product_size')
const lable_display = document.querySelector('#selected_option_display')

quantity_box.forEach(box=> {
  box.addEventListener("click",()=>{
    product_size.innerText = box.innerText.trim()
  })
})
options.forEach(option=>{
  option.addEventListener("click",()=>{
    details.removeAttribute("open")
    const text = option.textContent;
    lable_display.innerText = text.trim()
    product_variant.innerText = text.trim()
})
})

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

const tabs = document.querySelectorAll('.gush_product__description .tabs li')
const tabContents = document.querySelectorAll('.gush_product__description .tabs-content li')

tabs.forEach(tab => {
tab.addEventListener('click', () => {
const target = document.querySelector(tab.dataset.tabTarget)
tabContents.forEach(tabContent => {
tabContent.classList.remove('active')
})
tabs.forEach(tab => {
tab.classList.remove('active')
})
tab.classList.add('active')
target.classList.add('active')
})
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-gush"]) return;
  try {
    
const options = document.querySelectorAll('.product_variant_selection_container div')
const quantity_box = document.querySelectorAll('.quantity_selection_box div')
const details = document.querySelector('.product_variant_details')
const product_variant = document.querySelector('.current_selected_product_variant')
const product_size = document.querySelector('.current_selected_product_size')
const lable_display = document.querySelector('#selected_option_display')

quantity_box.forEach(box=> {
  box.addEventListener("click",()=>{
    product_size.innerText = box.innerText.trim()
  })
})
options.forEach(option=>{
  option.addEventListener("click",()=>{
    details.removeAttribute("open")
    const text = option.textContent;
    lable_display.innerText = text.trim()
    product_variant.innerText = text.trim()
})
})

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

const tabs = document.querySelectorAll('.gush_product__description .tabs li')
const tabContents = document.querySelectorAll('.gush_product__description .tabs-content li')

tabs.forEach(tab => {
tab.addEventListener('click', () => {
const target = document.querySelector(tab.dataset.tabTarget)
tabContents.forEach(tabContent => {
tabContent.classList.remove('active')
})
tabs.forEach(tab => {
tab.classList.remove('active')
})
tab.classList.add('active')
target.classList.add('active')
})
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-problem-tab"] && !Shopify.designMode) return;
  try {
    
const tabs = document.querySelectorAll('.the-problem-tab .tab');
const dropDownOptions = document.querySelectorAll('.the-problem-tab .option');
const tabContents = document.querySelectorAll('.the-problem-tab .tab-content');

dropDownOptions.forEach(option => {
  option.addEventListener('click', () => {
    const target = document.querySelector(option.dataset.optionTarget);
    tabContents.forEach(tabContent => {
      tabContent.classList.remove('active');
    });
    dropDownOptions.forEach(option => {
      option.classList.remove('active');
    });
    option.classList.add('active');
    target.classList.add('active');
		document.querySelector('.the-problem-tab details').removeAttribute("open");
		document.querySelector('.the-problem-tab summary span').textContent = option.textContent;
  })
})

tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    const target = document.querySelector(tab.dataset.tabTarget)
    tabContents.forEach(tabContent => {
      tabContent.classList.remove('active')
    })
    tabs.forEach(tab => {
      tab.classList.remove('active')
    })
    tab.classList.add('active')
    target.classList.add('active')
  })
})
	

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-solution-tab"] && !Shopify.designMode) return;
  try {
    
  const tabs = document.querySelectorAll('.the-solution-tab .tab')
  const tabContents = document.querySelectorAll('.the-solution-tab .tab-content')
  const dropDownOptions = document.querySelectorAll('.the-solution-tab .option');

  dropDownOptions.forEach(option => {
    option.addEventListener('click', () => {
      const target = document.querySelector(option.dataset.optionTarget);
      tabContents.forEach(tabContent => {
        tabContent.classList.remove('active');
      });
      dropDownOptions.forEach(option => {
        option.classList.remove('active');
      });
      option.classList.add('active');
      target.classList.add('active');
      document.querySelector('.the-solution-tab details').removeAttribute("open");
      document.querySelector('.the-solution-tab summary span').textContent = option.textContent;
    })
  })

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const target = document
        .querySelector(tab.dataset.tabTarget)
        tabContents
        .forEach(tabContent => {
          tabContent.classList.remove('active')
        })
        tabs
        .forEach(tab => {
          tab.classList.remove('active')
        })
        tab
        .classList
        .add('active')
      target
      .classList
      .add('active')
  })
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-testing-tab"] && !Shopify.designMode) return;
  try {
    
  const tabs = document.querySelectorAll('.the-testing-tab .tab');
  const dropDownOptions = document.querySelectorAll('.the-testing-tab .option');
  const tabContents = document.querySelectorAll('.the-testing-tab .tab-content');

  dropDownOptions.forEach(option => {
    option.addEventListener('click', () => {
      const target = document.querySelector(option.dataset.optionTarget);
      tabContents.forEach(tabContent => {
        tabContent.classList.remove('active');
      });
      dropDownOptions.forEach(option => {
        option.classList.remove('active');
      });
      option.classList.add('active');
      target.classList.add('active');
      document.querySelector('.the-testing-tab details').removeAttribute("open");
      document.querySelector('.the-testing-tab summary span').textContent = option.textContent;
    })
  })

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const target = document
        .querySelector(tab.dataset.tabTarget)
        tabContents
        .forEach(tabContent => {
          tabContent.classList.remove('active')
        })
        tabs
        .forEach(tab => {
          tab.classList.remove('active')
        })
        tab
        .classList
        .add('active')
      target
      .classList
      .add('active')
  })
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-film-warranty"]) return;
  try {
    
let Faqquestions = document.querySelectorAll(".faq_qus");
 
Faqquestions.forEach((question) => {
	question.addEventListener("click", (ele) => {
		let ans_id = question.dataset.contentId;
		let ans = document.getElementById(ans_id);

		let FaqiconPlus = question.querySelector(".icon-plus-new");
		let FaqiconMinus = question.querySelector(".icon-minus-new");
		 
		if(!FaqiconMinus.classList.contains('is-active')) {       
			FaqiconPlus.classList.remove("is-active");
			FaqiconPlus.classList.add("not-active");
			FaqiconMinus.classList.add("is-active");
			FaqiconMinus.classList.remove("not-active");
			ans.classList.add("is-active");
		} else {
			FaqiconMinus.classList.remove("is-active");
			FaqiconMinus.classList.add("not-active");
			FaqiconPlus.classList.add("is-active");
			FaqiconPlus.classList.remove("not-active");
			ans.classList.remove("is-active");
		}
	 });
 });

  } catch(e) { console.error(e); }
})();
})();
